import { Component } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css'
})
export class FooterComponent {
  footerMenu = [
    { label: 'Terms and Conditions', link: '#.' },
    { label: 'Careers', link: '#.' },
    { label: 'Clients', link: '#.' }
  ];

  contactInfo = [
    'Patton Street Caulfield East VIC 3145',
    'yoursite@domain.com'
  ];

  socialLinks = [
    { icon: 'bi-facebook', class: 'button-circle-social-facebook', link: '#.' },
    { icon: 'bi-twitter-x', class: 'button-circle-social-twitter', link: '#.' },
    { icon: 'bi-linkedin', class: 'button-circle-social-linkedin', link: '#.' }
  ];

}
